import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGrids = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4V4h4Zm6 0h-4V4h4Zm6 0h-4V4h4Z" />
  </svg>
);
export default SvgGrids;
